import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Dayjs } from 'dayjs';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';

const useGetTrackingSources = (
  identifier: string,
  name: string,
  from: Dayjs | null,
  to: Dayjs | null,
  sortBy: string,
  orderBy: string,
  rows: number,
  page: number,
) => {
  const navigate = useNavigate();

  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'name', name.trim());
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));
  appendQueryParamIfNotEmpty(queryParams, 'sortBy', sortBy);
  appendQueryParamIfNotEmpty(queryParams, 'orderBy', orderBy);
  appendQueryParamIfNotEmpty(queryParams, 'rows', rows.toString());
  appendQueryParamIfNotEmpty(queryParams, 'page', page.toString());

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`ads_management_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}tracking-sources?${queryParams}`).then((res: any) => res.data),
    {
      onSuccess: () => {
        navigate(`${window.location.pathname}?${queryParams.toString()}`, { replace: true });
      },
    },
  );
};

export default useGetTrackingSources;
export const useGetTrackingSourceOptions = (identifier: string, name: string) => useQuery(
  [`tracking_source_${identifier}`],
  () => dataFetch.get(`${DIGGER_API_SUFFIX}tracking-sources/options?name=${name}`).then((res: any) => res.data),
);

export const useGetTrackingSourceById = (identifier: string, trackingSourceId: string | null) => useQuery(
  [`ads_management_${identifier}`],
  () => trackingSourceId && dataFetch.get(`${DIGGER_API_SUFFIX}tracking-sources/${trackingSourceId}`).then((res: any) => res.data),
);

export const useGetTrackingSourceBySales = (identifier: string) => useQuery(
  [`tracking_source_${identifier}`],
  () => dataFetch
    .get(`${CORE_API_SUFFIX}ad/total/sales/by-tracking-source`)
    .then((res: any) => Object.entries(res.data.data).map(([id, totalSales]) => ({
      trackingSourceId: id,
      totalSales: Number(totalSales),
    }))),
);
